module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/b4f93075afbf79328945ae36479c9d93.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_sort_down.svg
// module id = 1yAK
// module chunks = 1